module.exports = __webpack_public_path__ + "media/images/social_icons/facebook_square-f27ef53cd63ded1792049a2e1a0e112e.png";